// Import the functions you need from the SDKs you need
import {FirebaseApp, initializeApp} from 'firebase/app';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBjyRI-OmIC4YrfhbnQMZ1Ane54mFKg4WU',
  authDomain: 'soli360k.firebaseapp.com',
  projectId: 'soli360k',
  storageBucket: 'soli360k.appspot.com',
  messagingSenderId: '940850609346',
  appId: '1:940850609346:web:a487c1196e1d1737088f5b',
};

// Initialize Firebase
let app: FirebaseApp | null = null;

const getFirebaseApp = () => {
  if (app == null) {
    app = initializeApp(firebaseConfig);
  }
  return app;
};

export default getFirebaseApp;
